import React, { useState } from 'react';
import axios from 'axios';
import { FileText, Loader2 } from 'lucide-react';
import { toast } from '../../hooks/use-toast';

const API = process.env.REACT_APP_BACKEND_URL;

export const OfferLetterLink = ({ offerId, testId }) => {
  const [busy, setBusy] = useState(false);
  if (!offerId) return null;

  const open = async (e) => {
    e.stopPropagation();
    const win = window.open('', '_blank');
    setBusy(true);
    try {
      const r = await axios.get(`${API}/api/offer-letters/${offerId}/download?format=pdf`, { responseType: 'blob' });
      const url = URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
      if (win) win.location.href = url; else window.location.href = url;
    } catch {
      if (win) win.close();
      toast({ title: 'Offer letter not found', description: 'It may have been deleted.', variant: 'destructive' });
    } finally { setBusy(false); }
  };

  return (
    <button type="button" onClick={open} className="inline-flex items-center gap-1 text-xs text-violet-700 hover:underline"
      data-testid={testId || `open-offer-letter-${offerId}`}>
      {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <FileText className="h-3 w-3" />} Open offer letter
    </button>
  );
};

export const JoinCountdown = ({ rec }) => {
  if (rec.status !== 'Offer Accepted' || !rec.expected_join_date) return null;
  const today = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Dubai' }));
  today.setHours(0, 0, 0, 0);
  const days = Math.round((new Date(`${rec.expected_join_date.slice(0, 10)}T00:00:00`) - today) / 86400000);
  const tone = days < 0 ? 'bg-gray-100 text-gray-600' : days <= 7 ? 'bg-amber-100 text-amber-800' : 'bg-emerald-50 text-emerald-700';
  const label = days < 0 ? `Join date passed ${-days}d ago` : days === 0 ? 'Joins today' : `Joins in ${days} day${days > 1 ? 's' : ''}`;
  return <span className={`text-[11px] font-semibold rounded-full px-2 py-0.5 ${tone}`} data-testid={`join-countdown-${rec.id}`}>{label}</span>;
};
